<template>
  <div
    class="pb-audio-player row no-gutters mini-audio-player"
  >
    <div class="main col min-w-0 p-0">
      <div class="pb-internal-player">
        <pb-player
          ref="pbPlayer"
          :options="videoOptions"
          :type="episode.type"
          :startAt="startAt"
          :episode="episode"
          @pause="pause"
          @play="play"
          @ready="ready"
          :crossorigin="null"
        ></pb-player>
        <player-loading></player-loading>
      </div>
    </div>


  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PbPlayer from "@/components/PbPlayer";
import PlayerLoading from "./PlayerLoading";
import { showWave } from "@/common/utils";
export default {
  name: "AudioPlayerMini",
  components: {
      PlayerLoading,
      PbPlayer},
  computed: {
    ...mapState([
      "setting",
      "startAt",
      "miniOnlyPlay",
    ]),
    ...mapGetters(["episode"]),
    videoOptions() {
      let controlBar = {
          fullscreenToggle: false,
          durationDisplay: false,
          mouseTimeDisplay: false,
          children: [
            "playToggle",
            "currentTimeDisplay",
            "progressControl",
            "remainingTimeDisplay",
            // "currentTimeDisplay",
            // "muteToggle",
            // "volumeControl",
            // "playbackRateMenuButton"
          ]
      };
      if(this.miniOnlyPlay){
        controlBar = {
            fullscreenToggle: false,
            durationDisplay: false,
            mouseTimeDisplay: false,
            children: [
              "playToggle",
            ]
        };
      }
      return {
        language: "en",
        autoplay: false,
        controls: true,
        // textTrackSettings:true,
        controlBar: controlBar,
        bigPlayButton: false,
        loadingSpinner: false,
        sources: [
          {
            src: this.episode.resource,
            type: this.episode.resourceMimetype
          }
        ],
      };
    }
  },
  data() {
    return {
      enableDraw: false,
      replayTimer: null,
      isShowShareDialog: false,
      isShowPodcastAppsDialog: false,
    };
  },
  watch: {
    skin() {
      // this.draw();
    },
    btnSkin() {
      // this.draw();
    },
  },
  methods: {
    ready() {
      if (this.episode.enableWave){
        //showWave();
      }
    },
    pause() {
    },
    play() {
    },
    seekBackward(){
      this.$refs.pbPlayer.addCurrentTime(- 15);
    },
    seekForward(){
      this.$refs.pbPlayer.addCurrentTime(+ 15);
    },
  }
};
</script>

<style lang="scss">
.mini-audio-player.pb-audio-player {
  background-color: transparent !important;
  border: none;
  height: 70px !important;
  max-height: 70px;
  border-radius: 5px;
  flex-shrink: 0;
  transition: all .2s;
  position: relative;
  width: 100%;
  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    .top-title-logo{
      padding-top: 3px;
      flex-shrink: 0;
      flex-grow: 0;
      max-height: 26px;
    }
    .pd-episode-name{
      flex-shrink: 0;
      flex-grow: 0;
    }

    .pb-brand-small-logo {
      padding-right: 10px !important;
     .icon-podbean-logo{
        width: 40px;
        color: #a1a1a1;
      }
    }

    .video-js {
      width: 100%;
      height: 44px;
      overflow: hidden;
      background-color: transparent;
      .vjs-play-progress{
        &:before{
          top: -0.4em;
        }
      }

      .vjs-control-bar {
        display: flex;
        height: 44px;
        background-color: transparent !important;
      }
    }
  }

  /* 整个播放条 */
  .pb-internal-player{
    position: relative;
    margin-top: 9px;
    flex-shrink: 1;
    flex-grow: 1;
    .vjs-text-track-display{
      .vjs-text-track-cue{
        //bottom: -2px !important;
        > div{
          color: #838383 !important;
          font-size: 13px;
        }
      }
    }
    .player-loading{
      height: 13px;
      left: 48px;
      top: -35px;
    }
  }
  .video-js{
     .vjs-control-bar{
       padding-left: 10px;
      .vjs-button{
        width: 44px;
        height: 44px;
        border-radius: 25px;
        transition: all 0.2s;
        text-align: center;
        line-height: 44px;
        position: relative;
        overflow: hidden;
        .vjs-icon-placeholder{
          color: #ffffff;
          font-size: 18px;
          display: block;
          position: absolute;
          left: 0;
          right: 0;
          top: -3px;
          bottom: 0;
          margin: auto;
          &:before{
            //line-height: unset;
            font-size: 31px;
          }
        }
        &:hover{
          opacity: 0.8;
        }
      }
      /* 播放开始默认时间样式 */
      .vjs-time-control{
        font-family: inherit;
        display: block !important;
        position: absolute;
        top: 7px;
        height: 16px;
        line-height: 16px;
        span{
          color: #aaaaaa !important;
        }
      }
      .vjs-current-time{
        left: 51px;
      }
      .vjs-remaining-time{
        right: 0;
      }
      /* 播放进度条样式 */
      .vjs-progress-control{
        margin-top: 8px;
        .vjs-progress-holder{
          font-size: 1.22em;
          background-color: #cfcfcf !important;
          .vjs-slider-bar{
            padding-left: 4px;
          }
        }
      }
    }
  }
  canvas {
    width: 100%;
    height: 34px;
    margin-top: 11px;
  }
}
</style>
